import { render, staticRenderFns } from "./PainelCustomerSuccess.vue?vue&type=template&id=5779f75a&scoped=true"
import script from "./PainelCustomerSuccess.vue?vue&type=script&lang=js"
export * from "./PainelCustomerSuccess.vue?vue&type=script&lang=js"
import style0 from "./PainelCustomerSuccess.vue?vue&type=style&index=0&id=5779f75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5779f75a",
  null
  
)

export default component.exports